import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Notification {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  title?: string;
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationsSubject = new Subject<Notification>();
  public notifications$ = this.notificationsSubject.asObservable();

  constructor() { }

  showSuccess(message: string, title?: string, duration: number = 5000) {
    this.showNotification({
      id: this.generateId(),
      type: 'success',
      message,
      title,
      duration
    });
  }

  showError(message: string, title?: string, duration: number = 7000) {
    this.showNotification({
      id: this.generateId(),
      type: 'error',
      message,
      title,
      duration
    });
  }

  showWarning(message: string, title?: string, duration: number = 6000) {
    this.showNotification({
      id: this.generateId(),
      type: 'warning',
      message,
      title,
      duration
    });
  }

  showInfo(message: string, title?: string, duration: number = 5000) {
    this.showNotification({
      id: this.generateId(),
      type: 'info',
      message,
      title,
      duration
    });
  }

  private showNotification(notification: Notification) {
    this.notificationsSubject.next(notification);
  }

  private generateId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }
} 